<template>
  <div v-loading="loading" class="stat-card purple-top">
    <div class="card-header">TỔNG SỐ HIỆN VẬT TIÊU BIỂU</div>
    <div class="card-body">
      <span class="value">{{ artifact | numberWithDelimiter }}</span>
      <span class="unit">hiện vật</span>
    </div>
    <div class="card-footer trend-up">
      <span class="arrow">▲</span> {{ newArtifact | numberWithDelimiter }} hiện vật mới kỳ này
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import { getArtifacts } from '@/services/artifact'

export default {
  name: 'ArtifactStatsCard',
  filters: {
    numberWithDelimiter(val) {
      if (val === undefined || val === null) return '0'
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  },
  data() {
    return {
      artifact: 0,
      newArtifact: 0,
      loading: false
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  watch: {
    language() {
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      const artifactParams = {
        page: 1,
        per_page: 1,
        locale: this.language
      }
      const oneWeekAgo = dayjs().subtract(7, 'day').format('YYYY-MM-DDT00:00:00')
      const newArtifactParams = {
        page: 1,
        per_page: 1,
        locale: this.language,
        created: oneWeekAgo
      }

      Promise.all([
        getArtifacts(artifactParams),
        getArtifacts(newArtifactParams)
      ]).then(([res1, res2]) => {
        if (res1 && res1.total !== undefined) {
          this.artifact = res1.total
        }
        if (res2 && res2.total !== undefined) {
          this.newArtifact = res2.total
        }
      }).catch((err) => {
        console.error('Failed to fetch artifact stats', err)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.stat-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-top: 4px solid #eaeaea;
  min-height: 125px;
  transition: all 0.3s ease;
  box-sizing: border-box;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  }

  &.purple-top { border-top-color: #8a2be2; }

  .card-header {
    font-size: 12px;
    font-weight: 700;
    color: #8c8c8c;
    margin-bottom: 12px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
  }

  .card-body {
    display: flex;
    align-items: baseline;
    margin-bottom: 8px;

    .value {
      font-size: 26px;
      font-weight: 800;
      color: #2c3e50;
      margin-right: 6px;
    }

    .unit {
      font-size: 14px;
      color: #7f8c8d;
      font-weight: 500;
    }
  }

  .card-footer {
    font-size: 12px;
    font-weight: 500;
    margin-top: 4px;

    &.trend-up {
      color: #27ae60;
      .arrow {
        font-size: 10px;
        margin-right: 2px;
      }
    }
  }
}
</style>
